
export default "/assets/memberful.6a85f26c.svg"